<template>
  <div class="pagesBox">
    <div style="height: 60px; width: 100%"></div>
    <div class="topBtns">
      <el-button style="margin-top: 10px" class="glo_bgcMainColor" @click="submit">保存</el-button>
    </div>
    <div class="formbox">
      <el-form ref="baseFormRed" label-width="130px" class="glo_formBox">
        <el-form-item label="异常单号:">
          <el-input v-model="exceptions.number" placeholder="自动带出" disabled></el-input>
        </el-form-item>
        <el-form-item label="运单号:">
          <el-input v-model="exceptions.waybillNumber" placeholder="自动带出" disabled></el-input>
        </el-form-item>
        <el-form-item label="不合格反馈单位:">
          <el-input v-model="exceptions.customerName" placeholder="自动带出" disabled></el-input>
        </el-form-item>
        <el-form-item label="反馈日期:">
          <el-input v-model="exceptions.happenTime" placeholder="自动带出" disabled></el-input>
        </el-form-item>
        <el-form-item label="不合格发现者/联系人:">
          <el-input v-model="exceptions.createUserName" placeholder="自动带出" disabled></el-input>
        </el-form-item>
        <el-form-item label="异常单创建日期:">
          <el-input v-model="exceptions.createTime" placeholder="自动带出" disabled></el-input>
        </el-form-item>

        <el-form-item label="编号:" required>
          <el-input v-model="addReqs.number" placeholder="请输入" clearable></el-input>
        </el-form-item>

        <el-form-item class="textArea" style="width: 100%" label="1、不符合/潜在的不符合问题的描述:">
          <el-input v-model="addReqs.problemDescription" type="textarea" rows="3" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item class="textArea" style="width: 100%" label="2、主要原因分析:">
          <el-input v-model="addReqs.mainCausesAnalysis" type="textarea" rows="3" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item class="textArea" style="width: 100%" label="3、下一步采取的改进方法:">
          <el-input v-model="addReqs.improvementMethod" type="textarea" rows="3" placeholder="请输入（逐项明确每项措施的内容责任人和完成日期）"></el-input>
        </el-form-item>
        <el-form-item class="textArea" style="width: 100%" label="4、改进方法实施结果记录:">
          <el-input v-model="addReqs.improvementResult" type="textarea" rows="3" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item class="textArea" style="width: 100%" label="5、措施效果的验证及评价:">
          <el-input v-model="addReqs.verificationEvaluation" type="textarea" rows="3" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  inject: ["reload"],
  components: {},
  data() {
    return {
      addReqs: {
        exceptionId: "",
        mainCausesAnalysis: "",
        improvementMethod: "",
        improvementResult: "",
        problemDescription: "",
        verificationEvaluation: "",
      },

      rectifyId: "",
      exceptions: {},
    };
  },
  watch: {},
  created() {},
  mounted() {},
  activated() {
    let { exceptions, rectifyId } = this.$route.query || {};
    if (exceptions) {
      this.exceptions = JSON.parse(exceptions);
      let { exceptionId } = this.exceptions;
      this.addReqs.exceptionId = exceptionId || "";
    }
    this.rectifyId = rectifyId || "";
  },
  destroyed() {},
  methods: {
    async submit() {
      let params = {
        ...this.addReqs,
      };
      if (this.rectifyId) {
        params.rectifyId = this.rectifyId;
        await this.$API.rectifyupdateRectify(params).then((res) => {
          if (res.data.status === "success") {
            this.$message.success(res.data.message || "操作成功");
            this.$TOOLS.closePage();
            this.$router.push({
              path: "/ExceptionManage/UnqualifiedList",
              query: {
                isreload: "isreload",
              },
            });
          } else {
            this.$message.error(`${res.data.message}---综合查询列表`);
          }
        });
      } else {
        params.outgoingId = this.outgoingId;
        await this.$API.rectifyaddRectify(params).then((res) => {
          if (res.data.status === "success") {
            this.$message.success(res.data.message || "操作成功");
            this.$TOOLS.closePage();
            this.$router.push({
              path: "/ExceptionManage/UnqualifiedList",
              query: {
                isreload: "isreload",
              },
            });
          } else {
            this.$message.error(`${res.data.message}---综合查询列表`);
          }
        });
      }
    },
  },
};
</script>
<style scoped lang='less'>
.topBtns {
  width: calc(100% - 270px);
  position: fixed;
  z-index: 10;
  top: 60px;
  left: 210px;
  background-color: #fff;
  // box-shadow: 2px 2px 5px #ccc;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
  margin: 0 30px;
  height: 50px;
}

.formbox {
  padding: 10px 30px 30px;
}

.textArea {
  height: auto !important;
}
.glo_formBox .textArea {
  /deep/ .el-form-item__content {
    height: auto !important;
    z-index: 0;
  }
}
</style>